import { render, staticRenderFns } from "./EditSegmentSettingsDialog.vue?vue&type=template&id=7f35a7c2&"
import script from "./EditSegmentSettingsDialog.vue?vue&type=script&lang=js&"
export * from "./EditSegmentSettingsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports